module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Thunder-07515ef521d468e2e3e6926d09bc9aa7.svg";